import Axios from "axios";

// Dropping the access token alone is not a logout. The refresh token stays in
// localStorage, so the next 401 sends the response interceptor through
// refreshAccessToken(), which mints a fresh access token and signs the user
// straight back in. The in-memory Authorization default has to go too, since a
// client-side route change never re-runs the bootstrap in index.tsx.
export function clearSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh");
  Axios.defaults.headers.common.Authorization = "";
}

// The exact inverse of logout(), and kept next to it so the pair stays in step.
// Every successful sign-in goes through here — password login and the
// set-password flow both — so neither can forget the two load-bearing steps.
export function establishSession(
  data: { token: string; refresh?: string },
  redirectTo = "/"
) {
  localStorage.setItem("token", data.token);
  if (data.refresh) localStorage.setItem("refresh", data.refresh);
  // Stamp before navigating, not after. The hard reload below re-runs
  // index.tsx, whose request interceptor force-logs-out when lastLogoutDate is
  // missing or from an earlier day — and the layout's fetchUserDetails() is the
  // first request through the default axios instance. Without this, anyone
  // logging in from a tab left open past midnight is thrown straight back to
  // /login, having just authenticated successfully.
  localStorage.setItem("lastLogoutDate", new Date().toString());
  // A hard navigation, not react-router. index.tsx sets the in-memory
  // Axios.defaults Authorization header only at module load, so a soft route
  // change would leave every subsequent request unauthenticated.
  window.location.href = redirectTo;
}

export function logout(redirectTo = "/login") {
  clearSession();
  // Stamp rather than clear: the request interceptor treats a missing
  // lastLogoutDate as "force a logout", so clearing it would make the first
  // API call on the login screen redirect and throw away the entered number.
  localStorage.setItem("lastLogoutDate", new Date().toString());
  window.location.replace(redirectTo);
}
